import React, {useState, useEffect, useRef} from 'react';
import { Link } from 'react-router-dom';
import './body.css';
import { FaUsers, FaChalkboardTeacher, FaBalanceScale, FaLightbulb } from "react-icons/fa";
import { motion, useAnimation } from 'framer-motion';

import { FaTimes, FaChevronRight, FaStar, FaHandsHelping, FaUserShield, FaChartLine, FaBook } from 'react-icons/fa';


function Body() {

  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  }


 

  const [counts, setCounts] = useState({
    members: 0,
    years: 0,
    programs: 0
  });

  const statsRef = useRef(null);
  const counted = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !counted.current) {
            counted.current = true;
            animateCounts();
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of section is visible
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current);
      }
    };
  }, []);

  const animateCounts = () => {
    const duration = 2000; // Animation duration in ms
    const steps = 100; // Number of steps
    const incrementMembers = 500 / steps;
    const incrementYears = 14 / steps;
    const incrementPrograms = 35 / steps;

    let currentStep = 0;
    const timer = setInterval(() => {
      currentStep++;
      setCounts({
        members: Math.min(500, Math.ceil(currentStep * incrementMembers)),
        years: Math.min(14, Math.ceil(currentStep * incrementYears)),
        programs: Math.min(35, Math.ceil(currentStep * incrementPrograms))
      });

      if (currentStep >= steps) {
        clearInterval(timer);
      }
    }, duration / steps);
  };


  return (
    <div className="ceylon-eye-care-home">
      {/* Hero Section */}
      <section className="hero-section-sec">
        <img src="/banner img1.png" alt="Ceylon Eye Care Banner" className="hero-banner-img" />
        <div className="hero-overlay">
          <div className="hero-content">
            <h1 className='cecoa-heading-body'>Ceylon Eye Care Optometric Association</h1>
            <p className="cecoa-subtitle-body">Enhancing Eye Health, Enriching Lives</p>
            <div className="hero-buttons">
              {/* <Link to="/findyouroptometrist" className="primary-btn"> */}
              {/* <button className="primary-btn">Find an Optometrist</button></Link> */}
           
            </div>
          </div>
        </div>
      </section>

 








      <div className='first-association-container'>
      <div className='association-content'>
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className='section-subtitle'>Welcome to</h2>
          <h1 className='section-title'>Ceylon Eye Care Optometric Association</h1>
          <p className='association-description'>
            Established as the premier professional body for optometrists in Sri Lanka, 
            we are committed to advancing eye care standards and promoting visual health 
            nationwide through advocacy, professional development, and public awareness.
          </p>
          <div className='key-facts'>
            <div className='fact-item'>
              <span className='fact-number'>500+</span>
              <span className='fact-label'>Member Practitioners</span>
            </div>
            <div className='fact-item'>
              <span className='fact-number'>14+</span>
              <span className='fact-label'>Years of Service</span>
            </div>
            <div className='fact-item'>
              <span className='fact-number'>Nationwide</span>
              <span className='fact-label'>Network</span>
            </div>
          </div>
          <Link to="/aboutus">
          <button className="cta-button">More Info</button></Link>
        </motion.div>
      </div>
      
      <div className='association-image'>
        <motion.img
          src='/first-mid-banner.jpeg'
          alt='Ceylon Eye Care Optometry Association Members'
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        />
      </div>
    </div>








      <div className="home-container">
      {/* Left Section */}
      <div className="home-left">
        <h1 className="home-title">Why choose CEOA?</h1>
        <div className="home-columns">
          {/* Employees and Students */}
          <div className="home-section">
            <h2 className="home-subtitle">For Employees and Students</h2>
            <ul className="home-list">
              <li>Better understanding of the significant role you play in providing great quality eye care for patients of all ages.</li>
              <li>Be more productive and confident in your work.</li>
              <li>Advance your career by developing new skills and staying up to date on current techniques and best practices.</li>
              <li>Learn how to better relate to your clients and understand their needs for the best customer service experience.</li>
              <li>Access to special CEOA member programs and offerings.</li>
            </ul>

            <div className="benefits-container">
  <a href="#" className="home-link" onClick={(e) => { e.preventDefault(); togglePopup(); }}>
    Learn More about CEOA Benefits
  </a>

  {isOpen && (
    <div className="benefits-popup-overlay" onClick={togglePopup}>
      <div className="benefits-popup" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={togglePopup}>
          <FaTimes />
        </button>
        
        <div className="popup-header">
          <h2>CEOA Member Benefits</h2>
          <p>Unlock exclusive advantages as a Ceylon Eye Care Optometry Association member</p>
        </div>
        
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon">
              <FaStar />
            </div>
            <h3>Professional Development</h3>
            <ul>
              <li><FaChevronRight className="list-icon" /> Free CPD courses</li>
              <li><FaChevronRight className="list-icon" /> Annual conference discounts</li>
              <li><FaChevronRight className="list-icon" /> Access to research journals</li>
            </ul>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">
              <FaHandsHelping />
            </div>
            <h3>Networking</h3>
            <ul>
              <li><FaChevronRight className="list-icon" /> National practitioner directory</li>
              <li><FaChevronRight className="list-icon" /> Mentorship programs</li>
              <li><FaChevronRight className="list-icon" /> Regional meetups</li>
            </ul>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">
              <FaUserShield />
            </div>
            <h3>Advocacy</h3>
            <ul>
              <li><FaChevronRight className="list-icon" /> Representation in health policy</li>
              <li><FaChevronRight className="list-icon" /> Legal support</li>
              <li><FaChevronRight className="list-icon" /> Practice standards protection</li>
            </ul>
          </div>
          
          <div className="benefit-card">
            <div className="benefit-icon">
              <FaChartLine />
            </div>
            <h3>Business Growth</h3>
            <ul>
              <li><FaChevronRight className="list-icon" /> Supplier discounts</li>
              <li><FaChevronRight className="list-icon" /> Practice marketing resources</li>
              <li><FaChevronRight className="list-icon" /> Insurance partnerships</li>
            </ul>
          </div>
        </div>
        
        <div className="popup-footer">
          <Link to="/joinusform">
            <button className="join-btn">
              Become a Member Today
            </button>
          </Link>
          <p className="contact-text">Questions? <a href="mailto:info@optometryassociation.lk">contact our team</a></p>
        </div>
      </div>
    </div>
  )}
</div>

          </div>

          {/* Employers */}
          <div className="home-section">
            <h2 className="home-subtitle">For Employers</h2>
            <ul className="home-list">
              <li>Help your employees reach their full potential.</li>
              <li>Foster an atmosphere of continual learning and professional development.</li>
              <li>Build a team focused on providing great customer experiences.</li>
              <li>Advance your practice by providing the best quality care through knowledgeable and skilled staff.</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="home-right">
        <img
          src="/members/082.jpg"
          alt="Testimonial"
          className="home-image"
        />
        <p className="home-testimonial">
          “Over the past few years, six of my team members went through the CEOA program, and I have had nothing but excellent feedback.
          The program provides context for why we do things in a particular way, and helped team members build their confidence to deliver
          quality service in practice. The CEOA program is an excellent training tool which continues to stimulate good conversation.
          I strongly recommend it to help bring your team members to the next level!”
        </p>
        <p className="home-author">– Optom. Himidira Bopearachchi</p>
      </div>
    </div>



{/* Leadership Section */}
<section className="leadership-section">
  <div className="section-header">
    <h2>Our Leadership</h2>
    <div className="divider"></div>
  </div>
  
  <div className="leadership-grid">
    {/* Main Leadership Cards (Founder, Chairmen, etc.) */}
    <div className="main-leaders-grid">
      {/* Founder */}
      <motion.div 
        className="leader-card founder-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <div className="leader-image">
          <img src="/members/062.jpg" alt="Optom. Naresh Pradhan" />
        </div>
        <div className="leader-info">
          <h4>Optom. Naresh Pradhan</h4>
          <p className="position">Founder</p>
          <p className="bio">Visionary founder who established the organization's core principles and direction.</p>
        </div>
      </motion.div>

      {/* Chairman Eye Care Group */}
      <motion.div 
        className="leader-card chairman-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        viewport={{ once: true }}
      >
        <div className="leader-image">
          <img src="/members/072.jpg" alt="Optom. M A D Deshapriya" />
        </div>
        <div className="leader-info">
          <h4>Optom. M A D Deshapriya</h4>
          <p className="position">Chairman Eye Care Group</p>
          <p className="bio">Leads the strategic vision and oversees all eye care initiatives.</p>
        </div>
      </motion.div>

      {/* Chairman */}
      <motion.div 
        className="leader-card chairman-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <div className="leader-image">
          <img src="/members/066.jpg" alt="Optom. Nishamani Duruge" />
        </div>
        <div className="leader-info">
          <h4>Optom. N. Arul Kumar</h4>
        <p className="position">President</p>
<p className="bio">
  Provides strategic leadership, guides the organization's vision and mission, and oversees governance, policy development, and key decision-making processes.
</p>
        </div>
      </motion.div>

      {/* Registrar */}
      <motion.div 
        className="leader-card registrar-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        viewport={{ once: true }}
      >
        <div className="leader-image">
          <img src="/members/079.jpg" alt="Optom. Erandi Perera Siriwardane" />
        </div>
        <div className="leader-info">
          <h4>Optom. K Lahiru M Rodrigo</h4>
       <p className="position">Vice President</p>
<p className="bio">
  Provides strategic leadership, supports the President in organizational governance, and helps drive key initiatives and member engagement.
</p>
        </div>
      </motion.div>



      <motion.div 
        className="leader-card registrar-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        viewport={{ once: true }}
      >
        <div className="leader-image">
          <img src="/members/073.jpg" alt="Optom. Erandi Perera Siriwardane" />
        </div>
        <div className="leader-info">
          <h4>Optom. Sujanima R Wijethunga</h4>
          <p className="position">Registrar</p>
          <p className="bio">Manages official records and regulatory compliance.</p>
        </div>
      </motion.div>



      {/* Treasurer */}
      <motion.div 
        className="leader-card treasurer-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        viewport={{ once: true }}
      >
        <div className="leader-image">
          <img src="/members/082.jpg" alt="Optom. K Lahiru M Rodrigo" />
        </div>
        <div className="leader-info">
          <h4>Optom. B A D T Himidira</h4>
          <p className="position">Treasurer</p>
          <p className="bio">Oversees financial management and budgeting.</p>
        </div>
      </motion.div>


    </div>

    {/* Board of Directors */}
    <div className="directors-section">
      <h3 className="directors-title">Board of Directors</h3>
      <div className="directors-grid">
        {[
          { name: "Optom. A D Isuru Sampath", image: "/members/071.jpg" },
          { name: "Optom. Lilendra Perera", image: "/members/044.jpg" },
          { name: "Optom. A A Prabha Perera", image: "/members/067.jpg" },
          // { name: "Optom. M H M S P Thilakarathne", image: "/members/070.jpg" },
          // { name: "Optom. H D S R Wijethunga", image: "/members/073.jpg" },
          // { name: "Optom. A D Isuru Sampath", image: "/members/071.jpg" }
        ].map((director, index) => (
          <motion.div 
            key={index}
            className="director-card"
            whileHover={{ y: -5 }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.5 + (index * 0.05) }}
            viewport={{ once: true }}
          >
            <div className="director-image">
              <img src={director.image} alt={director.name} />
            </div>
            <div className="director-info">
              <h5>{director.name}</h5>
              <p className="position">Board Member</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>

    {/* Counsellors */}
    {/* <div className="counsellors-section">
      <h3 className="counsellors-title">Counsellors</h3>
      <div className="counsellors-grid">
        {[
          { name: "Optom. Nadarajan Arulkumar", image: "/members/066.jpg" },
          { name: "Optom. N Udeni Gurusinghe", image: "/members/043.jpg" },
          { name: "Optom. Nishamani Duruge", image: "/members/075.jpg" }
        ].map((counsellor, index) => (
          <motion.div 
            key={index}
            className="counsellor-card"
            whileHover={{ y: -5 }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.8 + (index * 0.05) }}
            viewport={{ once: true }}
          >
            <div className="counsellor-image">
              <img src={counsellor.image} alt={counsellor.name} />
            </div>
            <div className="counsellor-info">
              <h5>{counsellor.name}</h5>
              <p className="position">Counsellor</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div> */}


{/* Media Chairperson */}

{/* <div className="media-chair-section">
  <h3 className="media-chair-title">Media Chairperson</h3>
  <div className="media-chair-grid">
    {[
      { name: "Optom. Ranjith Premarathne", image: "/members/068.jpg" }
    ].map((person, index) => (
      <motion.div 
        key={index}
        className="media-chair-card"
        whileHover={{ y: -5 }}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.8 + (index * 0.05) }}
        viewport={{ once: true }}
      >
        <div className="media-chair-image">
          <img src={person.image} alt={person.name} />
        </div>
        <div className="media-chair-info">
          <h5>{person.name}</h5>
          <p className="position">Media Chairperson</p>
        </div>
      </motion.div>
    ))}
  </div>
</div> */}


  </div>
</section>












      {/* Stats Section */}
      <section className="stats-section" ref={statsRef}>
      <div className="container">
        <div className="stats-grid">
          <div className="stat-item">
            <h3>{counts.members}+</h3>
            <p>Qualified Members</p>
          </div>
          <div className="stat-item">
            <h3>{counts.years}+</h3>
            <p>Years of Service</p>
          </div>
          <div className="stat-item">
            <h3>{counts.programs}+</h3>
            <p>Continuing Networking Programs</p>
          </div>
        </div>
      </div>
    </section>


      <section className="services-section">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <div className="services-grid">
          <div className="service-card">
            <FaUsers className="service-icon" />
            <h3>Professional Networking</h3>
            <p>Connect with optometrists and professionals through events, conferences, and forums.</p>
          </div>
          <div className="service-card">
        <FaBook className="service-icon" />
        <h3>Clinical Resources</h3>
        <p>Access to latest research, clinical guidelines, and practice management tools.</p>
      </div>
          <div className="service-card">
            <FaBalanceScale className="service-icon" />
            <h3>Advocacy & Representation</h3>
            <p>Representing optometrists’ interests with regulatory bodies and the public.</p>
          </div>
          <div className="service-card">
            <FaLightbulb className="service-icon" />
            <h3>Public Awareness</h3>
            <p>Promoting the importance of eye health and the role of optometrists in Sri Lanka.</p>
          </div>
        </div>
      </div>
    </section>



      {/* Membership CTA */}
      <motion.section 
        className="membership-cta"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="cta-content">
          <h3>Join Our Professional Community</h3>
          <p>
            Become part of Sri Lanka's leading optometric association and access exclusive benefits, 
            continuing education, and networking opportunities.
          </p>
          <Link to="/joinusform">
          <button className="cta-button">Join Now </button></Link>
        </div>
      </motion.section>






      
    </div>
  );
}

export default Body;